import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** システム状態 */
enum SysStatus {
  monthlyCarryOver = 'MONTHLY_CARRY_OVER',
  carryOverBeginningYear = 'CARRY_OVER_BEGINNING_YEAR',
  carryOverAdjustmentPeriod = 'CARRY_OVER_ADJUSTMENT_PERIOD',
}

const nameConfig = {
  monthlyCarryOver: new Map([
    [Locale.ja, '月次繰越'],
    [Locale.en, 'Monthly Carry Over'],
  ]),
  carryOverBeginningYear: new Map([
    [Locale.ja, '期首繰越'],
    [Locale.en, 'Carry Over Beginning Year'],
  ]),
  carryOverAdjustmentPeriod: new Map([
    [Locale.ja, '調整期間繰越'],
    [Locale.en, 'Carry Over Adjustment Period'],
  ]),
};

const toEnum = rawValueToEnum(SysStatus, SysStatus.monthlyCarryOver);
const toDisplay = enumToName(SysStatus, nameConfig);
const toDisplayWithPrefix = enumToName(SysStatus, nameConfig, { prefix: true });

export const sysStatus = {
  enum: SysStatus,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { SysStatus };
